import { Component, inject, signal } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { UserService } from '@api-services';
import { UserDto } from '@api-contracts';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ButtonComponent } from '@components';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { AuthenticationService } from '@services';
import { of } from 'rxjs';

@Component({
  selector: 'wun-gallery-artists',
  imports: [
    FormsModule,
    DatePipe,
    ButtonComponent,
    TranslocoDirective
  ],
  templateUrl: './gallery-artists.component.html',
  styleUrl: './gallery-artists.component.scss'
})
export class GalleryArtistsComponent {

  private readonly userService = inject(UserService);
  private readonly authenticationService = inject(AuthenticationService);
  private readonly translocoService = inject(TranslocoService);
  
  galleryCode = signal<string>('');
  page = signal<number>(1);
  pageSize = 20;
  Math = Math;

  artists = rxResource({
    params: () => ({ code: this.authenticationService.current()?.gallerySignCode, page: this.page() - 1 }),
    stream: (params) => {
      const filters: Record<string, any> = {
        profileType: 'ARTIST'
      };
      
      if (params.params.code) {
        filters['assignedToGallery'] = params.params.code;
      } else {
        return of({ data: [], hasNext: false, hasPrevious: false, totalCount: 0 });
      }
      
      return this.userService.usersGetArtists({
        filters: JSON.stringify(filters),
        page: params.params.page,
        pageSize: this.pageSize,
      });
    }
  });

  searchArtists() {
    this.page.set(1);
    this.artists.reload();
  }

  nextPage() {
    this.page.update(p => p + 1);
  }

  previousPage() {
    this.page.update(p => Math.max(1, p - 1));
  }

  getMailtoLink(): string {
    const galleryCode = this.authenticationService.current()?.gallerySignCode || '';
    const subject = this.translocoService.translate('galleryArtists.email.subject');
    const bodyTemplate = this.translocoService.translate('galleryArtists.email.body');
    const body = bodyTemplate.replace(/{code}/g, galleryCode);
    
    return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }
}
